<template>
  <div>
    <v-card width="1050">
      <v-card-title
      >DETTAGLI SESSIONE N° {{ this.idSessioneSelected }}
      </v-card-title
      >
      <v-card-text>
        <v-container
            style="
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: left;
          "
        >
          <v-text-field
              v-model="this.searchingCollo.text"
              label="CERCA LDV"
              prepend-inner-icon="mdi-magnify"
              variant="outlined"
              hide-details
              style="width: 100%; align-self: flex-end"
              single-line
          ></v-text-field>
          <v-data-table
              v-model:items-per-page-options="options"
              v-model:sort-by="sortBy"
              :fixed-header="true"
              :search="this.searchingCollo.text"
              :items="this.contenutoSessione.colli"
              :headers="this.headers"
              :loading="this.loading"
              style="
              border: 1px solid #d0d0d0;
              border-radius: 5px;
              max-height: 372px;
              margin-top: 10px;
            "
          >
            <template v-slot:item.emailAggiornatore="{ item }">
              <p
                  v-if="
                  item.emailAggiornatore === null ||
                  item.emailAggiornatore === 'null'
                "
              >
                NESSUNO
              </p>
              <p v-else>{{ item.emailAggiornatore }}</p>
            </template>
            <template v-slot:item.data_aggiornamento="{ item }">
              <p
                  v-if="
                  item.data_aggiornamento === null ||
                  item.data_aggiornamento === 'null'
                "
              >
                NESSUNO
              </p>
              <p v-else>{{ this.formattaDataOra(item.data_aggiornamento) }}</p>
            </template>
            <template v-slot:item.fuoriAwb="{ item }">
              <v-chip v-if="item.fuoriAwb" color="red" variant="flat">SI</v-chip>
              <p v-else>NO</p>
            </template>
          </v-data-table>
          <div
              style="
              display: flex;
              align-items: center;
              justify-content: start;
              column-gap: 10px;
            "
          >
            <v-btn
                variant="outlined"
                height="48px"
                style="margin-top: 20px; background-color: #1d6f42; color: white"
                @click="exportExcel"
            >ESPORTA EXCEL
            </v-btn
            >
          </div>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="black" variant="outlined" @click="closeDetails">
          CHIUDI
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {useStore} from "vuex";

const {DateTime} = require("luxon");
import Swal from "sweetalert2";

const axios = require("axios");
export default {
  name: "ContenutoSessione",

  props: {
    idSessioneSelected: {
      type: Number,
    },
    ldv: {
      type: String,
    },
    open: {
      type: Boolean,
    },
  },

  mounted() {
    this.loadDati();
    this.searchingCollo.text = this.ldv;
    console.log(this.searchingCollo.text);
    console.log(this.ldv);
  },

  data() {
    return {
      sortBy: [{key: "fuoriAwb", order: "desc"}],
      headers: [
        {title: "LDV OUT", value: "ldv", sortable: true},
        {title: "PALLET", value: "codicePallet", sortable: true},
        {title: "LDV IN CETOMS", value: "ldvInCetoms", sortable: true},
        {
          title: "N° PEZZI",
          value: "numeroPezzi",
          sortable: true,
          align: "center",
        },
        {
          title: "ULTIMO AGGIORNAMENTO",
          value: "data_aggiornamento",
          sortable: true,
        },
        {
          title: "ULTIMO AGGIORNATORE",
          value: "emailAggiornatore",
          sortable: true,
        },
        {title: "Fuori AWB", value: "fuoriAwb", sortable: true, align: "center"},
        {title: "", value: "id", sortable: false},
      ],
      searchingCollo: {
        text: "",
      },
      options: [10, 20, 30, 40, 50],
      contenutoSessione: {},
      loading: true,
      idBancale: {
        text: "",
      },
      editingLdv: null,
    };
  },

  setup() {
    const store = useStore();
    return {
      store,
      dateTime: DateTime,
    };
  },

  methods: {
    async exportExcel() {
      this.store.dispatch("setSnackbarText", "ESPORTAZIONE EXCEL IN CORSO");
      this.store.dispatch("toggleSnackBar", true);
      const apiUrl = `${this.$apiBaseUrl}/export/colliBySession/${this.idSessioneSelected}`;
      const bearerToken = this.$keycloak.token;

      const config = {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
        responseType: "blob",
      };
      try {
        const response = await axios.get(apiUrl, config);
        console.log(response);
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(response.data);
        link.download = "contenuto-sessione.csv";
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(link.href);
        document.body.removeChild(link);
      } catch (error) {
        console.error("Error:", error.message);
        Swal.fire({
          title: "ERRORE",
          text: `C'è stato un errore nel caricamento del file excel`,
          icon: "error",
        });
      }
      this.store.dispatch("toggleSnackBar", false);
    },
    async loadDati() {
      this.loading = true;
      const apiUrl = `${this.$apiBaseUrl}/session/details/${this.idSessioneSelected}`;
      const bearerToken = this.$keycloak.token;
      console.log(bearerToken);

      const config = {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      };

      try {
        const response = await axios.get(apiUrl, config);
        console.log("Response:", response.data);
        this.contenutoSessione = response.data;
      } catch (error) {
        console.error("Error:", error.message);
        this.contenutoSessione = {};
        Swal.fire({
          title: "ERRORE",
          text: `C'è stato un errore nel caricamento dei dettagli del bancale`,
          icon: "error",
        });
      }
      this.loading = false;
    },
    closeDetails() {
      this.store.dispatch("changeBodyClass", "");
      this.store.dispatch("closeContenutoSessione");
    },
    formattaDataOra(date) {
      return this.dateTime
          .fromISO(date + "Z")
          .setZone("Europe/Rome")
          .setLocale("it")
          .toFormat("dd/MM/yyyy | HH:mm:ss");
    },
  },

  watch: {
    open: function (newVal) {
      if (newVal) {
        this.loadDati();
      }
    },
  },
};
</script>

<style scoped></style>
